import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';
import { categories } from '@/mocks/categories';
import { formatDuration, formatViews } from '@/utils/format';

interface VideoCardProps {
  video: Video;
  compact?: boolean;
}

export default function VideoCard({ video, compact = false }: VideoCardProps) {
  const categoryName = categories.find((c) => c.id === video.categoryId)?.name ?? '视频';

  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block bg-background-100 border border-background-200 rounded-lg overflow-hidden hover:border-primary-400 transition-colors"
    >
      <div className="relative w-full aspect-video overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} - 靠逼视频`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-950/80 text-[11px] text-foreground-950 font-medium">
          {formatDuration(video.duration)}
        </span>
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-primary-500/90 text-background-50 text-[11px] font-medium">
          {categoryName}
        </span>
        <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-background-950/40">
          <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-2xl">
            <i className="ri-play-fill"></i>
          </span>
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-400 transition-colors">
          {video.title}
        </h3>
        {!compact && (
          <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
            {video.description}
          </p>
        )}
        <div className="mt-3 flex items-center justify-between text-xs text-foreground-600">
          <span className="flex items-center gap-1">
            <i className="ri-user-3-line"></i>
            {video.uploader}
          </span>
          <span className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {formatViews(video.views)}
            </span>
            <span>{video.uploadDate}</span>
          </span>
        </div>
      </div>
    </Link>
  );
}